import Common from './Common';

export default class Rating {
    static getRatings(userId) {
        const params = {
            url: `/v1/ratings/${userId}`,
            method: 'get',
            auth: false
        };
        return Common.request(params);
    }

    static translateUserRating(ratingId, targetLanguage) {
        return Common.request({
            url: `/v1/ratings/user/${ratingId}/translate`,
            method: 'get',
            data: {
                targeted_language: targetLanguage
            }
        });
    }

    static translateHomeRating(ratingId, targetLanguage) {
        return Common.request({
            url: `/v1/ratings/home/${ratingId}/translate`,
            method: 'get',
            data: {
                targeted_language: targetLanguage
            }
        });
    }
}
